/**
 * Whether the frontend (in-editor) Review moment auto-open is enabled.
 *
 * Driven by the `isFrontendReviewMomentEnabled` param on the
 * `platform_editor_ai_new_aifc_editor_experience` experiment. Read via the
 * no-exposure variant (exposure is already logged by `isNewAifcExperienceEnabled`
 * on the same paths). Mirrors `isDiffBasedSegmentingEnabled`.
 */
import { expValNoExposure } from '@atlaskit/tmp-editor-statsig/expVal';

export function isFrontendReviewMomentEnabled(): boolean {
	return expValNoExposure(
		'platform_editor_ai_new_aifc_editor_experience',
		'isFrontendReviewMomentEnabled',
		false,
	);
}
